export const PurchaseContractFinalizeSent = [
    {
        disabled: false,
        loading: false,
        key: "emit",
        icon: "fas fa-exchange",
        emit: "kooi:menu:order:diff_calculation",
        text: "labels.check_purchase.diff_calculation",
    },
    {
        disabled: false,
        loading: false,
        key: "emit",
        icon: "fas fa-funnel-dollar",
        emit: "kooi:menu:order:customs_invoice",
        text: "labels.customs_invoice.create",
    },
    {
        disabled: false,
        loading: false,
        icon: "fas fa-times",
        emit: "kooi:offer:menu:reject",
        key: "reject",
        text: "labels.order.reject"
    },
    {
        disabled: false,
        loading: false,
        key: "copy",
        text: "labels.offer.menus.copy"
    },
    {
        disabled: false,
        loading: false,
        icon: "fas fa-file-pdf",
        emit: "kooi:offer:menu:openpdf",
        key: "openpdf",
        text: 'labels.order.download_pdf',
        function: function (data) { return (data && data.pdf && data.pdf.find(item => (item.type == "c" || item.type == "po")) != undefined) }
    },
    {
        disabled: false,
        loading: false,
        icon: "fas fa-paper-plane",
        emit: "kooi:offer:menu:send_email",
        key: "sendmail",
        text: "labels.order.send_email",
        function: function (data) { return (data && data.pdf && data.pdf.find(item => (item.type == "c" || item.type == "po")) != undefined) }
    },
    {
        disabled: false,
        loading: false,
        key: "cancelOrder",
        icon: "fas fa-ban",
        emit: "kooi:menu:order:cancel",
        text: "labels.invoice.menus.cancellation",
        function: function (data) { return (data && !data.cancel_invoice_id) }
    },
    {
        disabled: false,
        loading: false,
        icon: "fas fa-clone",
        emit: "kooi:menu:copy_to_new_kooi",
        key: "emit",
        text: "labels.clone.copy_to_new_kooi"
    },
];

export const PurchaseContractMenus = {
            outgoing: [
                {
                    loading: false,
                    key: "sendNow",
                    text: "labels.invoice.menus.send_mail"
                },
                {
                    loading: false,
                    key: "abort",
                    icon: "fas fa-plane-slash",
                    text: "labels.invoice.menus.abort",
                    emit: "kooi:mails:menu:abort",
                },
                {
                    disabled: false,
                    loading: false,
                    key: "copy",
                    text: "labels.offer.menus.copy"
                },
                {
                    disabled: false,
                    loading: false,
                    icon: "fas fa-file-pdf",
                    emit: "kooi:offer:menu:openpdf",
                    key: "openpdf",
                    text: 'labels.order.download_pdf',
                    function: function (data) { return (data && data.pdf && data.pdf.find(item => (item.type == "c" || item.type == "po")) != undefined) }
                },
                {
                    disabled: false,
                    loading: false,
                    icon: "fas fa-file-invoice-dollar",
                    emit: "buttons:order:menu:createInvoice",
                    key: "accept",
                    text: "labels.order.create_invoice"
                },
                {
                    disabled: false,
                    loading: false,
                    key: "cancelOrder",
                    icon: "fas fa-ban",
                    emit: "kooi:menu:order:cancel",
                    text: "labels.invoice.menus.cancellation"
                },
                {
                    disabled: false,
                    loading: false,
                    icon: "fas fa-clone",
                    emit: "kooi:menu:copy_to_new_kooi",
                    key: "emit",
                    text: "labels.clone.copy_to_new_kooi"
                },
            ],
            rejected: [
                {
                    disabled: false,
                    loading: false,
                    icon: "fas fa-clipboard-check",
                    emit: "kooi:offer:menu:pdf_validation",
                    key: "validatepdf",
                    text: "labels.pdf.validation.pdf_validation",
                },
                {
                    disabled: false,
                    loading: false,
                    key: "copy",
                    text: "labels.offer.menus.copy"
                },
                {
                    disabled: false,
                    loading: false,
                    icon: "fas fa-file-pdf",
                    emit: "kooi:offer:menu:openpdf",
                    key: "openpdf",
                    text: 'labels.order.download_pdf',
                    function: function (data) { return (data && data.pdf && data.pdf.find(item => (item.type == "c" || item.type == "po")) != undefined) }
                },
                {
                    disabled: false,
                    loading: false,
                    icon: "fas fa-clone",
                    emit: "kooi:menu:copy_to_new_kooi",
                    key: "emit",
                    text: "labels.clone.copy_to_new_kooi"
                },
            ],
            finalize: PurchaseContractFinalizeSent,
            sent: PurchaseContractFinalizeSent,
            accepted: [
                {
                    disabled: false,
                    loading: false,
                    icon: "fas fa-clipboard-check",
                    emit: "kooi:offer:menu:pdf_validation",
                    key: "validatepdf",
                    text: "labels.pdf.validation.pdf_validation",
                },
                {
                    disabled: false,
                    loading: false,
                    icon: "fas fa-times",
                    emit: "kooi:offer:menu:reject",
                    key: "reject",
                    text: "labels.order.reject"
                },

                {
                    disabled: false,
                    loading: false,
                    key: "copy",
                    text: "labels.offer.menus.copy"
                },
                {
                    disabled: false,
                    loading: false,
                    icon: "fas fa-file-pdf",
                    emit: "kooi:offer:menu:openpdf",
                    key: "openpdf",
                    text: 'labels.order.download_pdf',
                    function: function (data) { return (data && data.pdf && data.pdf.find(item => (item.type == "c" || item.type == "po")) != undefined) }
                },
                {
                    disabled: false,
                    loading: false,
                    icon: "fas fa-paper-plane",
                    emit: "kooi:offer:menu:send_email",
                    key: "sendmail",
                    text: "labels.order.send_email",
                    function: function (data) { return (data && data.pdf && data.pdf.find(item => (item.type == "c" || item.type == "po")) != undefined) }
                },
                {
                    disabled: false,
                    loading: false,
                    icon_url: "/images/logos/mycroft-mc.png",
                    emit: "kooi:menu:finalize",
                    key: "finalize",
                    text: "labels.order.finalize",
                    function: function (data) { return (data && data.pdf && data.pdf.find(item => (item.type == "c" || item.type == "po")) != undefined) }
                },
                {
                    disabled: false,
                    loading: false,
                    key: "cancelOrder",
                    icon: "fas fa-ban",
                    emit: "kooi:menu:order:cancel",
                    text: "labels.invoice.menus.cancellation"
                },
                {
                    disabled: false,
                    loading: false,
                    icon: "fas fa-clone",
                    emit: "kooi:menu:copy_to_new_kooi",
                    key: "emit",
                    text: "labels.clone.copy_to_new_kooi"
                },
            ],
            open: [
                {
                    disabled: false,
                    loading: false,
                    icon: "fas fa-clipboard-check",
                    emit: "kooi:offer:menu:pdf_validation",
                    key: "validatepdf",
                    text: "labels.pdf.validation.pdf_validation",
                },
                {
                    disabled: false,
                    loading: false,
                    icon: "fas fa-times",
                    emit: "kooi:offer:menu:reject",
                    key: "reject",
                    text: "labels.order.reject"
                },

                {
                    loading: false,
                    disabled: false,
                    key: "copy",
                    text: "labels.offer.menus.copy"
                },
                {
                    disabled: false,
                    loading: false,
                    icon: "fas fa-file-pdf",
                    emit: "kooi:offer:menu:openpdf",
                    key: "openpdf",
                    text: 'labels.order.download_pdf',
                    function: function (data) { return (data && data.pdf && data.pdf.find(item => (item.type == "c" || item.type == "po")) != undefined) }
                },
                {
                    disabled: false,
                    loading: false,
                    icon: "fas fa-paper-plane",
                    emit: "kooi:offer:menu:send_email",
                    key: "sendmail",
                    text: "labels.order.send_email",
                    function: function (data) { return (data && data.pdf && data.pdf.find(item => (item.type == "c" || item.type == "po")) != undefined) }
                },
                {
                    disabled: false,
                    loading: false,
                    icon_url: "/images/logos/mycroft-mc.png",
                    emit: "kooi:menu:finalize",
                    key: "finalize",
                    text: "labels.order.finalize",
                    function: function (data) { return (data && data.pdf && data.pdf.find(item => (item.type == "c" || item.type == "po")) != undefined) }
                },
                {
                    disabled: false,
                    loading: false,
                    icon: "fas fa-clone",
                    emit: "kooi:menu:copy_to_new_kooi",
                    key: "emit",
                    text: "labels.clone.copy_to_new_kooi"
                },
            ],
        };
